import { experimentsService } from '@wix/cashier-common/dist/src/utils/experimentsService';
import React from 'react';
import { Experiment } from '../../../../types/Experiment';
import { DH } from '../../../../utils/DataHook';
import { t } from '../../../../utils/i18n';
import * as s from './styles.scss';

export const DropdownFieldLabel: React.FunctionComponent<{
  style: any;
  name: string;
  required: boolean;
  labelText: string;
}> = (props) => {
  return (
    <label
      data-hook={DH.PaymentDetails.DropdownField.Label}
      style={props.style}
      className={s.label}
      htmlFor={props.name}
    >
      {experimentsService.isExperimentEnabled(Experiment.AsteriskAfterText) ? (
        <>
          {props.labelText}
          {props.required && <span className={s.required}> *</span>}
        </>
      ) : (
        <>
          {props.required && <span className={s.required}>* </span>}
          {props.labelText}
        </>
      )}
    </label>
  );
};
DropdownFieldLabel.displayName = 'DropdownFieldLabel';

export const DropdownFieldErrorMessage: React.FunctionComponent<{
  name: string;
  errorMessage: string;
}> = (props) => {
  return (
    <label
      data-hook={DH.PaymentDetails.DropdownField.Error}
      className={s.errorLabel}
      htmlFor={props.name}
    >
      {t(props.errorMessage)}
    </label>
  );
};
DropdownFieldErrorMessage.displayName = 'DropdownFieldErrorMessage';
